module.exports = __webpack_public_path__ + "3d22e8b672ea5c04731bbaaebca23fbf.jpg";